/**
 * A panel of related content. The only surface component in the system — screens
 * are built by arranging cards, not by inventing new containers.
 */

import type { ReactNode } from 'react';
import styles from './Card.module.css';

export interface CardProps {
  title?: ReactNode;
  /** Rendered at the top right of the card, for one small action. */
  action?: ReactNode;
  children: ReactNode;
  /** Removes the inner padding, for a card whose body is a full-bleed table. */
  flush?: boolean;
}

export function Card({ title, action, children, flush = false }: CardProps) {
  return (
    <section className={styles.card}>
      {(title || action) && (
        <header className={styles.header}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {action}
        </header>
      )}
      <div className={flush ? styles.bodyFlush : styles.body}>{children}</div>
    </section>
  );
}
